import { useState, useCallback, useMemo } from 'react';

function useQueue({
  initialValues = [],
  limit
}) {
  const [{ state, queue }, setState] = useState({
    state: initialValues.slice(0, limit),
    queue: initialValues.slice(limit)
  });
  const add = useCallback(
    (...items) => setState((current) => {
      const results = [...current.state, ...current.queue, ...items];
      return {
        state: results.slice(0, limit),
        queue: results.slice(limit)
      };
    }),
    [limit]
  );
  const update = useCallback(
    (fn) => setState((current) => {
      const results = fn([...current.state, ...current.queue]);
      return {
        state: results.slice(0, limit),
        queue: results.slice(limit)
      };
    }),
    [limit]
  );
  const clearQueue = useCallback(
    () => setState((current) => ({ state: current.state, queue: [] })),
    []
  );
  return useMemo(
    () => ({
      state,
      queue,
      add,
      update,
      clearQueue
    }),
    [add, clearQueue, queue, state, update]
  );
}

export { useQueue };
//# sourceMappingURL=useQueue.mjs.map
